// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OkoQ","newExpiryDate":"styles_newExpiryDate__D14jb","footer":"styles_footer__2ryGl"};